module.exports = {
      id: "edit-usage",
      viewBox: "0 0 17.505 17.653",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#edit",
      toString: function () {
        return this.url;
      }
    }